module.exports = __webpack_public_path__ + "img/album05_03.1e6826db.jpg";